/* eslint-disable @typescript-eslint/no-var-requires */
import React, { FunctionComponent, MutableRefObject, useRef } from 'react';

import './animation038.less';

interface IAnimation038Item {
  icon: string;
  time: string;
  title: string;
  color: string;
  list: [];
}

interface IAnimation038Props {
  items: IAnimation038Item[];
  onCompleted: () => void;
}

const Animation038: FunctionComponent<IAnimation038Props> = ({
  items,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  return (
    <div className="animation038-content">
      <div ref={crrRef} className="animation038 component">
        {items.map((itm: IAnimation038Item, idx: number) => (
          <div
            key={idx}
            className={`animation038-item animation038-item-${idx}`}
          >
            <img className="animation038-icon" src={getImg(itm.icon)} alt="" />
            <>
              <div className="animation038-head">
                <div
                  className="animation038-time"
                  style={{
                    color: `${itm.color}`,
                  }}
                  dangerouslySetInnerHTML={{ __html: itm.time }}
                />
                <div
                  className="animation038-title"
                  dangerouslySetInnerHTML={{ __html: itm.title }}
                />
              </div>
            </>
            <div
              className="animation038-line"
              style={{
                backgroundColor: `${itm.color}`,
              }}
            />
            <div className="animation038-list">
              <ul>
                {itm.list.map((itms: string, idxs: number) => (
                  <li key={idxs}>{itms}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation038;
